import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console but don't crash the app
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Render children anyway - we don't want to break the UI
      // This prevents unhandled promise rejections from crashing the app
      return this.props.children;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
